/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { PureComponent } from 'react';

import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

import CssClassNames from '../../scss/CssClassNames';
import moduledStyles from './styles.module.scss';
const { className } = new CssClassNames(moduledStyles, ['utility']);

// TODO: This is really ugly
let allowClose = true;
let modalsOpen = 0;

export class Modal extends PureComponent {
    state = {
        preShow: false,
        show: false,
        usedButton: null,
        clickButtonClose: false,
        escLeave: false
    }

    constructor(props) {
        super(props);

        this.modalRef = null;

    }

    getNextFocusableElement(currentElement) {
        // Get all focusable elements
        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const elements = Array.from(document.querySelectorAll(focusableElements))
            .filter(el => !el.disabled && !el.getAttribute('aria-hidden'));

        // Find current position
        const currentIndex = elements.indexOf(currentElement);

        // Get next element (or first if at end)
        const nextIndex = currentIndex + 1 < elements.length ? currentIndex + 1 : 0;
        return elements[nextIndex];
    }

    componentDidUpdate(prevProps, prevState) {
        if (typeof window !== 'undefined') {
            if (this.state.preShow && !prevState.preShow) {
                const usedButton = document.activeElement;
                this.setState({ usedButton: usedButton })

                // this is used to inform the screen reader that the modal is opening
                var el = document.createElement("div");
                var id = "speak-" + Date.now();
                el.setAttribute("id", id);
                el.setAttribute("aria-live", "assertive");
                el.classList.add("visually-hidden");
                this.modalRef.appendChild(el);

                window.setTimeout(function () {
                    document.getElementById(id).innerHTML = "opened the dialog";
                }, 100);

                window.setTimeout(function () {
                    document.body.removeChild(document.getElementById(id));
                }, 1000);

                window.document.body.setAttribute('data-modal-open', 'true');
                this.modalRef.focus();

            } else if (!this.state.preShow && prevState.preShow && !modalsOpen) {
                window.document.body.removeAttribute('data-modal-open');

                // this is used to give focus back to the button that opened the modal when I
                // use tab navigation to leave the modal or close it on close button

                const elementToFocus = this.getNextFocusableElement(this.state.usedButton);

                if (elementToFocus && typeof elementToFocus.focus === 'function') {
                    setTimeout(() => {
                        try {
                            elementToFocus.focus({ focusVisible: true });
                            elementToFocus.scrollIntoView({
                                block: 'center'
                            });
                        } catch (error) {
                            console.error('Error focusing element:', error);
                        }
                    }, 200);
                }
            }
        }

        if (this.state.show !== prevState.show) {
            if (this.state.show) {
                modalsOpen += 1;
                if (this.modalRef) {
                    disableBodyScroll(this.modalRef);
                }
            } else {
                modalsOpen -= 1;
                allowClose = true;
                if (this.modalRef) {
                    enableBodyScroll(this.modalRef);
                }
            }

            if (this.props.onToggle) {
                this.props.onToggle(this.state.show);
            }
        }
    }

    toggle = () => {

        if (!allowClose) {
            allowClose = true;
            return;
        }

        if (this.state.show) {

            // this is used to inform the screen reader that the modal is closing
            var el = document.createElement("div");
            var id = "speak-" + Date.now();
            el.setAttribute("id", id);
            el.setAttribute("aria-live", "assertive");
            el.classList.add("visually-hidden");
            this.modalRef.appendChild(el);

            window.setTimeout(function () {
                document.getElementById(id).innerHTML = "closed the dialog";
            }, 100);

            window.setTimeout(function () {
                document.body.removeChild(document.getElementById(id));
            }, 1000);

            this.setState({ show: false });
            window?.document?.body?.removeAttribute('data-modal-open');
            setTimeout(() => {
                this.setState({ preShow: false });
            }, 400);
        } else {
            this.setState({ preShow: true });
            // enableBodyScroll(this.modalRef);
            setTimeout(() => {
                this.setState({ show: this.state.preShow });
            }, 400);
        }
    }

    closeModal = () => {
        // enableBodyScroll(this.modalRef);
        this.setState({ clickButtonClose: true });
        allowClose = true;
        this.toggle();
    }

    toggleFromBackground = () => {
        if (this.props.disableBackgroundClose) {
            return;
        }


        this.toggle();
    }

    keydownToggle = (e) => {
        if (e.key === 'Escape') {
            this.setState({ escLeave: true });
            // enableBodyScroll(this.modalRef);
            allowClose = true;
            this.toggle();
        }
    }

    unallowClose = () => {
        allowClose = false;
    }

    render() {
        const { show, preShow } = this.state;
        const {
            children,
            header = null,
            footer = null,
            wrapperClassName = '',
            closeButtonClassName = '',
            bodyClassName = '',
            dialogClassName = '',
            headerClassName = '',
            footerClassName = '',
            size
        } = this.props;

        return (
            <>
                {preShow ? <div {...className(`modal-backdrop backdrop-fade-opacity ${show ? 'show' : ''}`)} /> : null}
                <div
                    ref={el => this.modalRef = el}
                    {...className(`modal fade fade-opacity ${wrapperClassName} ${show ? 'show' : ''}`)}
                    tabIndex="0"
                    onBlur={(e) => {
                        if (e.relatedTarget !== e.currentTarget && !e.currentTarget.contains(e.relatedTarget) && !this.state.clickButtonClose && !this.state.escLeave) {
                            // allowClose = true;
                            // this.toggle();
                            const closeButton = document.getElementById('close-modal-button');
                            if (closeButton) {
                                closeButton.focus();
                            }
                        }
                    }}
                    onClick={this.toggleFromBackground}
                    onKeyDown={this.keydownToggle}
                    style={preShow ? { display: 'block' } : {}}
                    aria-modal="true"
                    role="alertdialog"
                >
                    <div
                        onClick={this.unallowClose}
                        onKeyDown={this.unallowClose}
                        {...className(`modal-dialog modal-dialog-centered modal-${size ? size : 'lg'} ${dialogClassName}`)}
                        role="document"
                    >
                        <div {...className('modal-content')}>
                            {header ? (
                                <div {...className(`modal-header ${headerClassName}`)}>
                                    {header}
                                    <button
                                        id="close-modal-button"
                                        type="button"
                                        data-dismiss="modal"
                                        onClick={this.closeModal}
                                        aria-label="Fechar"
                                        {...className(closeButtonClassName)}
                                    >
                                        <span>×</span>
                                    </button>
                                </div>
                            ) : null}
                            {children ? (<div {...className(`modal-body ${bodyClassName}`)}>{children}</div>) : null}
                            {footer ? (
                                <div {...className(`modal-footer justify-content-center ${footerClassName}`)}>
                                    {footer}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}